import { trackEvent } from "./analytics";

export const trackMarketingFunnel = (eventName, params = {}) => {
  trackEvent(eventName, {
    category: "marketing_funnel",
    ...params,
  });
};
